import React, { useContext, useState } from "react";
import { CommandBarButton } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OnPremOrderListingContext } from "../context/OnPremOrderListingContext";
import { OnPremOrderListingFilters } from "../hooks/useOnPremOrderListingFilters";

export interface ExportOnPremOrdersForProcessingButtonProps {
    filters: OnPremOrderListingFilters;
}

export const ExportOnPremOrdersForProcessingButton: React.FC<ExportOnPremOrdersForProcessingButtonProps> = ({
    filters
}: ExportOnPremOrdersForProcessingButtonProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { pinnedItems } = useContext(OnPremOrderListingContext);

    const { exportOnPremOrdersForProcessing } = useOrdersModuleApi();

    const handleClick = async () => {
        setIsLoading(true);

        exportOnPremOrdersForProcessing({
            sortBy: filters.sortBy,
            sortOrder: filters.sortOrder,
            statuses: filters.statuses,
            pONumber: filters.pONumber,
            content: filters.content,
            distributorId: filters.distributorId,
            airlineIds: filters.airlineIds,
            systemIds: filters.systemIds,
            orderIds: pinnedItems,
            dueDateFrom: filters.dueDateFrom?.toISOString(),
            dueDateTo: filters.dueDateTo?.toISOString()
        })
            .then(({ fileUrl }) => {
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "onPremOrdersFile");
                document.body.appendChild(link);
                link.click();
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <CommandBarButton onClick={handleClick} text="Export for processing" icon="Generate" isLoading={isLoading} />
    );
};
